//import * as l from './loginUtils';
import {FunctionalComponent, h} from "@stencil/core";

export const LoginFormType = {
  LOGIN: "login",
  SIGN_UP: "sign up",
  PASSWORD_RECOVER: "recover",
  COMPLETE_CREATION: "complete_creation"
};

export interface PageHeaderProps {
  textBefore: string
  showListener?: (visible: boolean) => void
}

export const PageHeaderInline: FunctionalComponent<PageHeaderProps> = ({ textBefore, showListener = null }) => {
  return <login-icon textBefore={textBefore} showListener= {showListener} onLogin={(_role, userAction) => { if (userAction) window.location.reload()}} onLogout={() => {window.location.reload()}}/>
};

export const PageHeaderBlock: FunctionalComponent<PageHeaderProps> = ({ textBefore, showListener = null }) => {
  return <div><PageHeaderInline textBefore={textBefore} showListener= {showListener} /></div>
};

export class ElitePage {
  refresher: ()=> void
  visible: boolean
}
